import React from 'react';
import { formatPhoneNumber } from '../../helpers/transform';

type TerritoryManagerCardProps = {
  name: string;
  title: string;
  email: string;
  phone: string;
  image: string;
};

function TerritoryManagerCard({
  name,
  title,
  email,
  phone,
  image
}: TerritoryManagerCardProps) {
  return (
    <article className="territory-manager-card">
      <picture className="territory-manager-card__picture">
        <img src={`${image}?width=150`} alt={name}  />
      </picture>
      <div className="territory-manager-card__content">
        <h3 className="territory-manager-card__name">{name}</h3>
        {title && <p className="territory-manager-card__title">{title}</p>}
        {email && (
          <a href={`mailto:${email}`} className="link--inline link--icon-left">
            <span className="sr-only">Email:</span>
            {email}
            <svg role="presentation">
              <use xlinkHref="#red-email-icon"></use>
            </svg>
          </a>
        )}
        {phone && (
          <a href={`tel:${phone}`} className="link--inline link--icon-left">
            <span className="sr-only">Phone Number:</span>
            {formatPhoneNumber(phone)}
            <svg role="presentation">
              <use xlinkHref="#red-phone-icon"></use>
            </svg>
          </a>
        )}
      </div>
    </article>
  );
}

export default TerritoryManagerCard;
